
import UpdateDriver from "../../../components/@users/drivers/UpdateDriver";

import { routeTypes } from "../../../hooks/useSystemRoutes";

export default function ProfilePage() {

    // return UpdateDriver({
    //     routeType: routeTypes.driver,
    //     isOwnProfile: true
    // })

    return (
        <UpdateDriver 
            routeType={routeTypes.driver}
            isOwnProfile={Boolean(true)}
        />
    )
}       